import React from 'react';
import { ReactComponent as Logo } from 'assets/new-logo-simple.svg';

function AppMenuHeader() {
  return (
    <header className="flex flex-col items-center justify-start flex-shrink-0 cursor-pointer select-none bg-jcap-700 h-18">
      <div
        className="flex items-center justify-end flex-shrink-0 w-full pr-5"
        id="logoWrapper"
      >
        <Logo className="w-20 py-3" />
      </div>
      <main className="flex-grow mb-2 text-gray-200 truncate" />
    </header>
  );
}

export default AppMenuHeader;
